import { render, staticRenderFns } from "./lv-base-table.vue?vue&type=template&id=7e880a6d&"
import script from "./lv-base-table.vue?vue&type=script&lang=js&"
export * from "./lv-base-table.vue?vue&type=script&lang=js&"
import style0 from "./lv-base-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports